//import Vue from 'vue'
import MultipleStateCheckbox from './components/MultipleStateCheckbox'

//Vue.component('MultipleStateCheckbox', MultipleStateCheckbox)

export default MultipleStateCheckbox